import React, { ReactNode, useContext, useEffect } from 'react';
import { AuthContext } from '../Auth/components/AuthProvider';
import { Loading } from './system/Loading';
import { StateContext } from '../util/providers/StateProvider';
import { NavigateFunction, useNavigate } from 'react-router';

export const LoginPage: React.FC = (): ReactNode => {
  const {actions} = useContext(AuthContext);
  const { originMandantSettings } = useContext(StateContext);
  const navigate: NavigateFunction = useNavigate();

  useEffect((): void => {
    if(!originMandantSettings.loginEnabled) {
      return void navigate('/');
    }
    window.location.href = actions.getAuthUrl();
  }, []);

  return <Loading/>;
};

export default LoginPage;
